import styled from 'styled-components'
import { StepLabel as MuiStepLabel } from '@material-ui/core'

export const StepLabel = styled(MuiStepLabel)`
	.MuiStepLabel-label {
		color: ${props => props.theme.grey.main};
	}
`
